/**
 * Feature Icons block
 *
 * UI for handling the logic and animations of feature icons block
 */

const $ = require( 'jQuery' );

var itblFeatureIcons = function(el){

  //setup some variables
  this.$el        = $(el);
  this.$iconsRow  = this.$el.find('.itbl-b-feature-icons__cards-wrap-row');

  this.init();
};

itblFeatureIcons.prototype.init = function(){

  this.events();

};

itblFeatureIcons.prototype.events = function(){
  $(document).on('scroll', this.event__handleScroll.bind(this));
};

itblFeatureIcons.prototype.event__handleScroll = function(){
  var scroll = $(window).scrollTop();

  this.$iconsRow.each(function(){
    var $this = $(this);

    if ( $this.offset().top < scroll + $(window).height() - 150 ) {
      $this.addClass('in-view');
    }
  });
}

$(function(){
  $('.itbl-b-feature-icons').each(function(){
    new itblFeatureIcons(this);
  });
});
